import useSWR from "swr";
import useBoardAndItems from "../context/useBoardAndItems";
import useUser from "../context/userHook";
import logger from "../../lib/logger";
import { MondayApiQueryInstance } from "../../services/monday/monday-service-ts";

const useCheckAccessLevelCurrentBoard = () => {
  const { userId } = useUser();
  const { currentBoard } = useBoardAndItems();

  const fetcher = async () => {
    try {
      const response = await MondayApiQueryInstance.getAccessLevel([currentBoard!]);

      return response;
    } catch (error: any) {
      logger.error("Error checking access level:", error);
      throw error;
    }
  };

  const { isLoading, error, data, isValidating, mutate } = useSWR(userId && currentBoard ? `checkAccessLevel:${userId}:${currentBoard}` : null, () =>
    fetcher()
  );

  return {
    isLoading,
    error,
    data,
    isValidating,
    mutate,
  };
};

export default useCheckAccessLevelCurrentBoard;
